import { useLocation } from 'react-router-dom'
import { parse } from 'query-string'
import useVenueEnabledFeaturePreviews, { VenueFeaturePreviews } from './use-venue-enabled-feature-previews'

const useIsVenueBrandingEnabled = () => {
  const location = useLocation()
  const query = parse(location.search, { parseBooleans: true }) as { [key: string]: string }
  const { origin, venueId, hideEversportsBranding: hideEversportsBrandingQueryParam } = query

  const { enabledFeatures } = useVenueEnabledFeaturePreviews({ venueId })

  // Keep the feature switch for backward compatibility until clients have migrated to the query parameter
  const isHideEversportsBrandingFeatureEnabled =
    origin === 'widget' && enabledFeatures.includes(VenueFeaturePreviews.HIDE_EVERSPORTS_BRANDING)

  return Boolean(hideEversportsBrandingQueryParam) || isHideEversportsBrandingFeatureEnabled
}

export { useIsVenueBrandingEnabled }
